import { columns } from "./ClientsTableProperties";

interface TableHeaderProps {
  sortBy?: string;
  onSort: (key: string) => void;
}

const ClientsTableHeader = ({ sortBy, onSort }: TableHeaderProps) => {
  const getSortIndicator = (key: string) => {
    if (!sortBy) return '↕';
    const match = sortBy.split(',').find(f => f.replace(/^-/, '') === key);
    if (!match) return '↕';
    return match.startsWith('-') ? '↓' : '↑';
  };

  const handleSort = (key: string) => {
    const fields = sortBy ? sortBy.split(',') : [];
    const match = fields.find(f => f.replace(/^-/, '') === key);
    const rest = fields.filter(f => f.replace(/^-/, '') !== key);

    let newFields: string[];
    if (!match) newFields = [key, ...rest];
    else if (!match.startsWith('-')) newFields = [`-${key}`, ...rest];
    else newFields = rest;

    onSort(newFields.join(','));
  };

  return (
    <tr>
      {columns.map(col => (
        <th
          key={col.key}
          style={{
            width: col.width,
            cursor: col.sortable ? 'pointer' : 'default',
            userSelect: 'none',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          onClick={() => col.sortable && handleSort(col.key)}
        >
          {col.label} {col.sortable && <span>{getSortIndicator(col.key)}</span>}
        </th>
      ))}
    </tr>
  );
};

export default ClientsTableHeader;